export enum ActionTypes {
  LOAD_UPCOMING_MAINTENANCES_REQUEST = 'LOAD_UPCOMING_MAINTENANCES_REQUEST',
  LOAD_UPCOMING_MAINTENANCES_SUCCEEDED = 'LOAD_UPCOMING_MAINTENANCES_SUCCEEDED',
  LOAD_UPCOMING_MAINTENANCES_FAILED = 'LOAD_UPCOMING_MAINTENANCES_FAILED',

  EDIT_REMINDERS_REQUEST = 'EDIT_REMINDERS_REQUEST',
  DELETE_REMINDERS_REQUEST = 'DELETE_REMINDERS_REQUEST',
  SETUP_REMINDERS_REQUEST = 'SETUP_REMINDERS_REQUEST',
}
